import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const SemesterSetupLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'SemesterSetup' */ './components/SemesterSetup'
		)
);

export default (store) => {
	return {
		path: 'semester-setup/:campusId?',
		element: <AsyncLoading component={<SemesterSetupLazy />} />,
	};
};
